import React, { useEffect, useState, useContext } from "react";
import DynamicGrid from "../../Components/DynamicGrid/DynamicGrid";
import Heading from "../../Components/Heading/Heading";
import { useNavigate } from "react-router-dom";
import { APICall } from "../../Helpers/API/APICalls";
import {
  CheckCostCenter,
  getSelfGridData,
} from "../../Helpers/API/APIEndPoints";
import { LoaderContext, getContext } from "../../Helpers/Context/Context";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { TextField } from "@mui/material";
import SelectForm from "../../Components/SelectForm/SelectForm";
import { useCommonDropDown } from "./CommonDropDown/useCommonDropDown";
import moment from "moment";
import { Tooltip } from "antd";

const SelfRatingScreen = () => {
  let now = new Date();
  let navigate = useNavigate();
  const { EmployeeId, RoleId, UserName } = getContext();
  const [selfGridData, setSelfGridData] = useState<any>([]);
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [displayCol, setdisplayCol] = useState(true);
  const [start, setStart] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [count, setTotalCount] = useState(0);
  const [filterDate, setFilterDate] = useState(
    new Date(now.getFullYear(), now.getMonth() - 1, 1)
  );
  const [filterStatus, setFilterStatus] = useState<any>(null);
  const { statusDropDown, teamMemberDropDown } = useCommonDropDown();

  useEffect(() => {
    (async () => {
      await loadGridData();
    })();
  }, [filterDate, filterStatus]);

  const ConvertArrayToString = async (arr) => {
    if (arr && arr.length > 0) {
      let s = [];
      arr.map((v) => s.push(v.value));
      return s.join(",");
    } else {
      return "";
    }
  };

  const loadGridData = async () => {
    let statusIds = await ConvertArrayToString(filterStatus);

    showLoader();
    let reqParams = {
      start: start,
      pageSize: pageSize,
      RatingDate: moment(filterDate).format("YYYY-MM-DD"),
      StatusIds: statusIds,
      EmployeeId: Number(EmployeeId),
    };
    const { data } = await APICall(getSelfGridData, "POST", reqParams);

    await setSelfGridData(data);
    hideLoader();
  };

  const option = {
    selectableRows: "none",
    // count: count,
    // rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: true,
    onChangeRowsPerPage: (num) => {},
    onSearchChange: (searchText) => {},
    onColumnSortChange: async (sortColumn, sortDirection) => {},
    // onChangePage: async () => {

    // },
  };

  // Added custom color for tooltip
  const customColors = ["#2755f3"];

  const selfGridColumns = [
    {
      name: "id",
      label: "Id",
      options: {
        display: false,
        filter: false,
        sort: true,
      },
    },
    {
      name: "ratingDate",
      label: "Date",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => {
          const date = new Date(value);
          const year = date.getFullYear();
          const month = date.toLocaleString("default", { month: "long" });
          return `${year} ${month}`;
        },
      },
    },
    // {
    //   name:"engagement",
    //   label:"Engagement",
    //   options:{
    //     display:displayCol,
    //     filter:false,
    //     sort:true,
    //   }
    // },
    // {
    //   name:"lead",
    //   label:"Team Lead",
    //   options:{
    //   display:displayCol,
    //     filter:false,
    //     sort:true,
    //   }
    // },

    // {
    //   name:"manager",
    //   label:"Project Manager",
    //   options:{
    //   display:displayCol,
    //     filter:false,
    //     sort:true,
    //   }
    // },
    {
      name: "finalManager",
      label: "Reporting Manager",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "finalManagerRatingLabel",
      label: "Final Rating",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "ratingStatusLabel",
      label: "Status",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "",
      label: "Action",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta) => {
          let detailID = tableMeta.tableData[tableMeta.rowIndex].id;
          // console.log(
          //   "ratingscreen",
          //   tableMeta.tableData[tableMeta.rowIndex].id
          // );
          return (
            <>
              <Tooltip title="Edit" color={customColors[0]}>
                <a
                  className="action_icon"
                  onClick={(e) => {
                    e.preventDefault();

                    navigate("edit", { state: detailID });
                  }}
                >
                  <i className="fa fa-pencil" aria-hidden="true"></i>
                  {/* 
                  selfGridData.some(item => item.ratingStatusLabel !== "Self Rating Pending") ? (
                    <i className="fa fa-eye" aria-hidden="true"></i>
                  ) : (
                      <i className="fa fa-pencil" aria-hidden="true"></i>
                  )
                */}
                </a>
              </Tooltip>
            </>
          );
        },
      },
    },
  ];

  return (
    <>
      {/* <RatingComponent type={"SELF"}/> */}
      <Heading title={"Self Rating"} />
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label className="d-block">
                Date <sup>*</sup>
              </label>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  views={["year", "month"]}
                  label="Year and Month"
                  value={filterDate}
                  onChange={(e) => {
                    setFilterDate(e);
                  }}
                  renderInput={(params) => (
                    <TextField size="small" {...params} />
                  )}
                />
              </LocalizationProvider>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>Status</label>
              <SelectForm
                options={statusDropDown}
                placeholder="Status"
                value={filterStatus}
                onChange={(e) => {
                  setFilterStatus(e);
                }}
                isMulti={true}
                noIndicator={false}
                noSeparator={false}
              />
            </div>
          </div>
          <div className="col-lg-12">
            <div className="d-flex gap-2 justify-content-between">
              <div>
                <button
                  onClick={() => navigate("edit")}
                  className="btn btn-update"
                >
                  Create
                </button>
              </div>
            </div>
          </div>
          <div className="col-lg-12 mt-3">
            <DynamicGrid
              options={option}
              data={selfGridData}
              columns={selfGridColumns}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default SelfRatingScreen;
